import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
const { __ } = wp.i18n;

const Default = ({ post }) => {
	const linkText = __('Read more', 'wex');
	const ariaLabel = __('Blog post', 'wex');

	return (
		<div role="group" aria-label={ariaLabel}>
			<a href={post.permalink} className="post-slide-card">
				<figure
					className="post-slide-card__img-wrapper"
					dangerouslySetInnerHTML={{ __html: post.featured_image }}
				/>
				<div className="post-slide-card__text">
					{post.category && 1 !== post.category.term_id && (
						<div className="post-slide-card__category">{post.category.name}</div>
					)}
					<h2
						className="post-slide-card__title"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.post_title) }}
					/>
					<div className="btn-tertiary post-slide-card__link">
						{linkText}
						<svg
							role="img"
							aria-label="Arrow right"
							width="16"
							height="16"
							viewBox="0 0 16 16"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M6 15C5.71875 15 5.46875 14.9062 5.28125 14.7188C4.875 14.3438 4.875 13.6875 5.28125 13.3125L10.5625 8L5.28125 2.71875C4.875 2.34375 4.875 1.6875 5.28125 1.3125C5.65625 0.90625 6.3125 0.90625 6.6875 1.3125L12.6875 7.3125C13.0938 7.6875 13.0938 8.34375 12.6875 8.71875L6.6875 14.7188C6.5 14.9062 6.25 15 6 15Z"
								fill="#1D2C38"
							/>
						</svg>
					</div>
				</div>
			</a>
		</div>
	);
};

Default.displayName = 'Default';

export default Default;
